module.exports = __webpack_public_path__ + "files/238629060f4af522d8a558269881943f.png";